import React, { useEffect, useRef, useState } from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import productSlide1 from "../../assets/images/product-slide1.webp";
import productSlide2 from "../../assets/images/product-slide2.webp";
import productSlide3 from "../../assets/images/product-slide3.webp";
import avatarImage from "../../assets/images/nick-user2.png";
import projectIcon1 from "../../assets/images/project-icon1.svg";
import projectIcon2 from "../../assets/images/project-icon2.svg";
import projectIcon3 from "../../assets/images/project-icon3.svg";
import tickCircle from "../../assets/images/tick-circle.svg";
import tickCircleWhite from "../../assets/images/tick-circle-white.svg";
import happyIcon from "../../assets/images/happy-icon.svg";
import activity from "../../assets/images/activity.svg";
import requiest from "../../assets/images/requiest.svg";
import feedback from "../../assets/images/feedback.svg";

import keepRequiest from "../../assets/images/keep-requiest.svg";
import providQuote from "../../assets/images/provid-quote.svg";
import trakProject from "../../assets/images/trak-project.svg";
import strimlineProject from "../../assets/images/strimline-project.svg";

import referralsUser1 from "../../assets/images/referrals-user1.svg";
import referralsUser2 from "../../assets/images/referrals-user2.svg";
import referralsUser3 from "../../assets/images/referrals-user3.svg";

import lovely from "../../assets/images/lovely.svg";
import crownPro from "../../assets/images/crown-pro.svg";
import share from "../../assets/images/share.svg";
import closeCircle from "../../assets/images/close-circle.svg";

import innovatImg1 from "../../assets/images/innovat-img1.webp";
import innovatImg2 from "../../assets/images/innovat-img2.webp";
import innovatImg3 from "../../assets/images/innovat-img3.webp";
import mobilApp from "../../assets/images/mobil-app.webp";
import appPlay from "../../assets/images/app-play.svg";
import googlePlay from "../../assets/images/google-play.svg";
import popularPost from "../../assets/images/popular-post-img_2.png";

import "../../assets/styles/style.css";
import APIService from "../../utils/APIService";
import Slider from "react-slick"; // Import react-slick
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Accordion from "react-bootstrap/Accordion";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { scrollToId, selectLoader } from "../../utils/Helper";

const Home = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isFirstRender = useRef(true); // ✅ Track initial render
  const [blogsList, setBlogsList] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [categoryId, setCategoryId] = useState(null);
  const [tagId, setTagId] = useState(null);
  const [blogsLoading, setBlogsLoading] = useState(false);
  const [activeKey, setActiveKey] = useState("0");
  const [plans, setPlans] = useState([]);
  const [isActivating, setActivating] = useState(false);
  // useEffect(() => {
  //   setTimeout(() => {
  //     window.scrollTo(0, 0);
  //   }, 100);
  //   fetchBlogList(1);
  // }, []);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false; // ✅ Prevent second execution in Strict Mode

      if (location.state?.scrollTo) {
        setTimeout(() => {
          const element = document.getElementById(location.state.scrollTo);
          if (element) {
            element.scrollIntoView({ behavior: "smooth" });
          }
          navigate(".", { replace: true, state: {} }); // ✅ Clear state after scrolling
        }, 300);
      } else {
        window.scrollTo({ top: 0, behavior: "smooth" }); // ✅ Scroll to top only on manual reload
      }
    }
  }, [location, navigate]);

  const activateSubscription = async (itemPriceId) => {
    if (!itemPriceId || isActivating) return;

    try {
      setActivating(true);

      const payload = { itemPriceId };

      const response = await APIService.post(
        "/subscription/create-checkout-hosted-page",
        payload,
      );

      const checkoutUrl = response?.hostedPage?.url;

      if (!checkoutUrl) {
        throw new Error("Stripe checkout URL not found.");
      }

      // 🔥 Redirect to Stripe Checkout
      window.location.href = checkoutUrl;
    } catch (error) {
      console.error("Error starting Stripe checkout:", error);
      setActivating(false);
    }
  };

  useEffect(() => {
    fetchBlogList(1);
    fetchPlans();
  }, []);

  // const chargebee = new Chargebee({
  //   site: "happyending-test",
  //   apiKey: "https://js.chargebee.com/v2/chargebee.js",
  // });

  const fetchBlogList = async (page) => {
    try {
      // Set loading states
      setBlogsLoading(true);
      setLoading(true);

      // Construct the API URL
      const url = `/blogs?page=${page}&limit=3&status=published`;

      // Fetch data from API
      const response = await APIService.get(url);

      // Filter out drafted blogs
      const blogsData = response.blogs;

      // Update state
      // setBlogsList((prevBlogs) => [...prevBlogs, ...blogsData]);
      setBlogsList(blogsData);
      setCurrentPage(response.currentPage);
      setTotalPages(response.totalPages);
    } catch (error) {
      console.error("Error fetching blogs:", error);
    } finally {
      // Reset loading states
      setLoading(false);
      setBlogsLoading(false);
    }
  };

  const fetchPlans = async () => {
    try {
      const planData = await APIService.get(`/subscription/plans`);
      console.log(planData);
      setPlans(planData.plans);
      // setBlogDetails(blogData);
    } catch (error) {
      // setError(true);
      console.error("Error fetching blog details:", error);
    } finally {
      setLoading(false);
    }
  };

  const loadMoreBlogs = () => {
    if (currentPage < totalPages) {
      fetchBlogList(currentPage + 1);
    }
  };

  const handleCategoryChange = (id) => {
    setCategoryId(id);
    setBlogsList([]); // Clear the list when changing categories
    setCurrentPage(1); // Reset the page number
  };

  const handleTagChange = (id) => {
    setTagId(id);
    setBlogsList([]); // Clear the list when changing tags
    setCurrentPage(1); // Reset the page number
  };

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
  };

  const referralSlider = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const viewBlogPost = (slug) => {
    navigate(`/blog/${slug}`);
  };

  const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    const options = { year: "numeric", month: "long", day: "numeric" };
    const formattedDate = date.toLocaleDateString("en-US", options);
    return formattedDate;
  };

  return (
    <div className="wrapper">
      <Header isBackEnable={false} />
      <main className="main-curve-top">
        <div className="happy-left">&nbsp;</div>
        <div className="happy-right">&nbsp;</div>
        <section className="join-sec text-center">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="content-block">
                  <h1 className="title h1">
                    Most Project Management Tools Focus on Tasks—We Focus on
                    Your Clients.
                  </h1>
                  <div className="join-btn-group">
                    <a href="#" className="btn active">
                      Start Your First Project for Free
                    </a>
                    <a href="#" className="btn">
                      Watch a 2-Minute Demo
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="product-slider">
            <Slider {...sliderSettings}>
              <div>
                <img src={productSlide1} alt="productSlide1" />
              </div>
              <div>
                <img src={productSlide2} alt="productSlide2" />
              </div>
              <div>
                <img src={productSlide3} alt="productSlide3" />
              </div>
            </Slider>
          </div>
        </section>

        <section className="projects-sec" id="benifits">
          <div className="container">
            <h2 className="title">Effortless, Timely, & Profitable Projects</h2>
            <p>
              Happy Ending keeps clients informed, engaged, and accountable,
              ensuring smooth collaboration and on-time project delivery—without
              the stress. Stay in control, maximize profitability, and finish
              every project with confidence.
            </p>
            {/* <img src={happyIcon} alt="happyIcon" className="happyIcon" /> */}
            <iframe
              src="https://lottie.host/embed/96894531-8aa5-4a98-a2bf-0781322d6eb5/rN2tVLe271.json"
              className="img-gif happyIcon"
            ></iframe>
            <div className="row">
              <div className="col-lg-4 col-md-4">
                <div className="projects-col-content">
                  <img
                    src={projectIcon1}
                    alt="projectIcon1"
                    className="projectIcon"
                  />
                  <h4>Stay on Track with Project Deadlines</h4>
                  <ul>
                    <li>
                      <img
                        src={tickCircle}
                        alt="tickCircle"
                        className="tickCircle"
                      />
                      <p>
                        Helps you set clear start and end dates for every
                        project.
                      </p>
                    </li>
                    <li>
                      <img
                        src={tickCircle}
                        alt="tickCircle"
                        className="tickCircle"
                      />
                      <p>
                        Provides automatic reminders for upcoming and overdue
                        tasks.
                      </p>
                    </li>
                    <li>
                      <img
                        src={tickCircle}
                        alt="tickCircle"
                        className="tickCircle"
                      />
                      <p>
                        Reduces last-minute rushes by keeping progress visible.
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-4 col-md-4">
                <div className="projects-col-content">
                  <img
                    src={projectIcon2}
                    alt="projectIcon2"
                    className="projectIcon"
                  />
                  <h4>Effectively Managing Client Expectations</h4>
                  <ul>
                    <li>
                      <img
                        src={tickCircle}
                        alt="tickCircle"
                        className="tickCircle"
                      />
                      <p>
                        Keeps scope clear by documenting agreements and changes.
                      </p>
                    </li>
                    <li>
                      <img
                        src={tickCircle}
                        alt="tickCircle"
                        className="tickCircle"
                      />
                      <p>
                        Reduces miscommunication with structured updates and
                        approvals.
                      </p>
                    </li>
                    <li>
                      <img
                        src={tickCircle}
                        alt="tickCircle"
                        className="tickCircle"
                      />
                      <p>
                        Prevents project creep by defining what’s included (and
                        what’s not).{" "}
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-4 col-md-4">
                <div className="projects-col-content">
                  <img
                    src={projectIcon3}
                    alt="projectIcon3"
                    className="projectIcon"
                  />
                  <h4>Follow a Proven Success Framework</h4>
                  <ul>
                    <li>
                      <img
                        src={tickCircle}
                        alt="tickCircle"
                        className="tickCircle"
                      />
                      <p>Uses structured workflows to ensure consistency.</p>
                    </li>
                    <li>
                      <img
                        src={tickCircle}
                        alt="tickCircle"
                        className="tickCircle"
                      />
                      <p>
                        Provides clear steps to manage projects from kickoff to
                        completion.
                      </p>
                    </li>
                    <li>
                      <img
                        src={tickCircle}
                        alt="tickCircle"
                        className="tickCircle"
                      />
                      <p>
                        Eliminates guesswork with a repeatable, tested
                        process.{" "}
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <a
              href="#"
              className="get-start-btn"
              onClick={(e) => scrollToId(e, "pricing")}
            >
              Get Started!
            </a>
          </div>
        </section>
        <section className="client-sec" id="streamline">
          <div className="container">
            <div className="head-top-content">
              <h2>Streamline Your Projects & Elevate Client Collaboration</h2>
              <p>
                Keep projects organized, improve communication, and manage tasks
                effortlessly—all in one place.
              </p>
            </div>
            <div className="row">
              <div className="col-lg-6 col-md-6">
                <Accordion
                  defaultActiveKey="0"
                  activeKey={activeKey}
                  onSelect={(eventKey) => setActiveKey(eventKey)}
                >
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                      Centralized Client Communication
                    </Accordion.Header>
                    <Accordion.Body>
                      <p>
                        Prevents scattered conversations across emails, sms,
                        texts, and calls.
                      </p>
                      <ul>
                        <li>
                          <img
                            src={tickCircleWhite}
                            alt="tickCircle"
                            className="tickCircleWhite"
                          />
                          <p>
                            Prevents scattered conversations across emails, sms,
                            texts, and calls.
                          </p>
                        </li>
                        <li>
                          <img
                            src={tickCircleWhite}
                            alt="tickCircle"
                            className="tickCircleWhite"
                          />
                          <p>
                            Keeps all project discussions in one easy-to-access
                            location.
                          </p>
                        </li>
                        <li>
                          <img
                            src={tickCircleWhite}
                            alt="tickCircle"
                            className="tickCircleWhite"
                          />
                          <p>
                            Provides a clear record of decisions and requests.
                          </p>
                        </li>
                      </ul>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="1">
                    <Accordion.Header>Change Order Management</Accordion.Header>
                    <Accordion.Body>
                      <p>
                        Easily manage out-of-scope requests, approvals, and
                        pricing adjustments.
                      </p>
                      <ul>
                        <li>
                          <img
                            src={tickCircleWhite}
                            alt="tickCircle"
                            className="tickCircleWhite"
                          />
                          <p>
                            Tracks out-of-scope requests separately from
                            standard project work.
                          </p>
                        </li>
                        <li>
                          <img
                            src={tickCircleWhite}
                            alt="tickCircle"
                            className="tickCircleWhite"
                          />
                          <p>
                            Simplifies approval and pricing adjustments for
                            extra work.
                          </p>
                        </li>
                        <li>
                          <img
                            src={tickCircleWhite}
                            alt="tickCircle"
                            className="tickCircleWhite"
                          />
                          <p>
                            Ensures all changes are documented, reducing
                            disputes.
                          </p>
                        </li>
                      </ul>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="2">
                    <Accordion.Header>
                      Collect & Leverage Client Feedback
                    </Accordion.Header>
                    <Accordion.Body>
                      <p>
                        Use one dedicated channel for all project communication,
                        preventing confusion and messy back-and-forth across
                        email and group texts.
                      </p>
                      <ul>
                        <li>
                          <img
                            src={tickCircleWhite}
                            alt="tickCircle"
                            className="tickCircleWhite"
                          />
                          <p>
                            Prevents scattered conversations across emails,
                            texts, and calls.
                          </p>
                        </li>
                        <li>
                          <img
                            src={tickCircleWhite}
                            alt="tickCircle"
                            className="tickCircleWhite"
                          />
                          <p>
                            Keeps all project discussions in one easy-to-access
                            location.
                          </p>
                        </li>
                        <li>
                          <img
                            src={tickCircleWhite}
                            alt="tickCircle"
                            className="tickCircleWhite"
                          />
                          <p>
                            Provides a clear record of decisions and requests.
                          </p>
                        </li>
                      </ul>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="3">
                    <Accordion.Header>
                      Keep Small Requests Organized
                    </Accordion.Header>
                    <Accordion.Body>
                      <p>
                        Track and manage requests efficiently without derailing
                        your project timeline.
                      </p>
                      <ul>
                        <li>
                          <img
                            src={tickCircleWhite}
                            alt="tickCircle"
                            className="tickCircleWhite"
                          />
                          <p>
                            Allows clients and service providers to submit small
                            asks in the form of requests without impacting
                            scope.
                          </p>
                        </li>
                        <li>
                          <img
                            src={tickCircleWhite}
                            alt="tickCircle"
                            className="tickCircleWhite"
                          />
                          <p>
                            Keeps requests separate from major change orders for
                            better organization.
                          </p>
                        </li>
                        <li>
                          <img
                            src={tickCircleWhite}
                            alt="tickCircle"
                            className="tickCircleWhite"
                          />
                          <p>
                            Prevents last-minute surprises by ensuring all tasks
                            are documented and addressed.
                          </p>
                        </li>
                      </ul>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="4">
                    <Accordion.Header>
                      Provide Quoites for Out-Of-Scope Work
                    </Accordion.Header>
                    <Accordion.Body>
                      <p>
                        Offer clear pricing options and transparency on project
                        changes.
                      </p>
                      <ul>
                        <li>
                          <img
                            src={tickCircleWhite}
                            alt="tickCircle"
                            className="tickCircleWhite"
                          />
                          <p>
                            Attach a quote to change orders with Good, Better,
                            Best pricing options.
                          </p>
                        </li>
                        <li>
                          <img
                            src={tickCircleWhite}
                            alt="tickCircle"
                            className="tickCircleWhite"
                          />
                          <p>
                            Helps clients make informed decisions by comparing
                            different pricing tiers.
                          </p>
                        </li>
                        <li>
                          <img
                            src={tickCircleWhite}
                            alt="tickCircle"
                            className="tickCircleWhite"
                          />
                          <p>
                            Ensures all additional work is approved before
                            impacting scope or budget.
                          </p>
                        </li>
                      </ul>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="5">
                    <Accordion.Header>Track Project Analytics</Accordion.Header>
                    <Accordion.Body>
                      <p>
                        Get a high-level view of project progress, deadlines,
                        and financials in one place.
                      </p>
                      <ul>
                        <li>
                          <img
                            src={tickCircleWhite}
                            alt="tickCircle"
                            className="tickCircleWhite"
                          />
                          <p>
                            Track active projects, pending approvals, and
                            upcoming deadlines at a glance.
                          </p>
                        </li>
                        <li>
                          <img
                            src={tickCircleWhite}
                            alt="tickCircle"
                            className="tickCircleWhite"
                          />
                          <p>
                            Identify bottlenecks early to keep work moving
                            smoothly.
                          </p>
                        </li>
                        <li>
                          <img
                            src={tickCircleWhite}
                            alt="tickCircle"
                            className="tickCircleWhite"
                          />
                          <p>
                            Gain insights into overall project health,
                            sign-offs, and client engagement.
                          </p>
                        </li>
                      </ul>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="6">
                    <Accordion.Header>
                      Organize & Streamline Project Management
                    </Accordion.Header>
                    <Accordion.Body>
                      <p>
                        Use a simple, visual system to track progress, assign
                        tasks, and ensure accountability.
                      </p>
                      <ul>
                        <li>
                          <img
                            src={tickCircleWhite}
                            alt="tickCircle"
                            className="tickCircleWhite"
                          />
                          <p>
                            Uses a visual system to track tasks and milestones.
                          </p>
                        </li>
                        <li>
                          <img
                            src={tickCircleWhite}
                            alt="tickCircle"
                            className="tickCircleWhite"
                          />
                          <p>
                            Makes it easy to assign responsibilities and follow
                            progress.
                          </p>
                        </li>
                        <li>
                          <img
                            src={tickCircleWhite}
                            alt="tickCircle"
                            className="tickCircleWhite"
                          />
                          <p>
                            Keeps teams and clients aligned with a clear
                            workflow.
                          </p>
                        </li>
                      </ul>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </div>
              <div className="col-lg-6 col-md-6">
                <Accordion
                  defaultActiveKey="0"
                  activeKey={activeKey}
                  className="accordion-img"
                >
                  <Accordion.Item eventKey="0">
                    <Accordion.Body>
                      <img src={activity} alt="activity" className="img-item" />
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="1">
                    <Accordion.Body>
                      <img src={requiest} alt="requiest" className="img-item" />
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="2">
                    <Accordion.Body>
                      <img src={feedback} alt="feedback" className="img-item" />
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="3">
                    <Accordion.Body>
                      <img
                        src={keepRequiest}
                        alt="keepRequiest"
                        className="img-item"
                      />
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="4">
                    <Accordion.Body>
                      <img
                        src={providQuote}
                        alt="providQuote"
                        className="img-item"
                      />
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="5">
                    <Accordion.Body>
                      <img
                        src={trakProject}
                        alt="trakProject"
                        className="img-item"
                      />
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="6">
                    <Accordion.Body>
                      <img
                        src={strimlineProject}
                        alt="strimlineProject"
                        className="img-item"
                      />
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </div>
            </div>
          </div>
        </section>

        <section className="slack-integration-sec" id="slack-integration">
          <div className="container">
            <div className="head-top-content slack-integration-heading">
              <span className="slack-integration-label">Slack Integration</span>
              <h2>How to connect HappyEnding to Slack</h2>
              <p>
                The HappyEnding Slack integration is available inside your
                HappyEnding account.
              </p>
            </div>

            <div className="slack-integration-card">
              <h3>To connect Slack:</h3>
              <ol className="slack-integration-steps">
                <li>
                  <span>1</span>
                  <p>Log in to your HappyEnding account.</p>
                </li>
                <li>
                  <span>2</span>
                  <p>
                    Open the Integrations page from your profile menu, or open
                    a project and select <strong>Connect Slack</strong> from the
                    project menu.
                  </p>
                </li>
                <li>
                  <span>3</span>
                  <p>
                    Click <strong>Connect Slack</strong>.
                  </p>
                </li>
                <li>
                  <span>4</span>
                  <p>
                    Choose the Slack workspace and channel where HappyEnding
                    should post activity updates.
                  </p>
                </li>
                <li>
                  <span>5</span>
                  <p>Review and approve the Slack permissions.</p>
                </li>
                <li>
                  <span>6</span>
                  <p>
                    After authorization, HappyEnding will start sending project
                    activity updates to the selected Slack channel.
                  </p>
                </li>
              </ol>

              <aside className="slack-integration-note">
                You can disconnect Slack at any time from the Integrations page
                or from the connected project.
              </aside>
            </div>
          </div>
        </section>

        <section className="claude-connector-sec" id="claude-connector">
          <div className="container">
            <div className="head-top-content claude-connector-heading">
              <span className="claude-connector-label">Claude Connector</span>
              <h2>Connect HappyEnding to Claude</h2>
              <p>
                Add HappyEnding as a custom connector in Claude to access it
                directly from your conversations.
              </p>
            </div>

            <ol className="claude-connector-steps">
              <li>
                <span className="claude-step-number">1</span>
                <div>
                  <h3>Go to Connectors</h3>
                  <p>
                    In Claude, navigate to <strong>Customize</strong> &gt;{` `}
                    <strong>Connectors</strong>.
                  </p>
                </div>
              </li>
              <li>
                <span className="claude-step-number">2</span>
                <div>
                  <h3>Add a custom connector</h3>
                  <p>
                    Click <strong>+</strong>, then select{` `}
                    <strong>Add custom connector</strong>.
                  </p>
                </div>
              </li>
              <li>
                <span className="claude-step-number">3</span>
                <div>
                  <h3>Paste your MCP URL</h3>
                  <p>
                    Enter{` `}
                    <a
                      href="https://api.happyending.ai/mcp"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      https://api.happyending.ai/mcp
                    </a>{` `}
                    as the server URL.
                  </p>
                </div>
              </li>
              <li>
                <span className="claude-step-number">4</span>
                <div>
                  <h3>Add OAuth (optional)</h3>
                  <p>
                    Under <strong>Advanced settings</strong>, add your OAuth
                    Client ID and Secret if your server uses them.
                  </p>
                </div>
              </li>
              <li>
                <span className="claude-step-number">5</span>
                <div>
                  <h3>Authenticate</h3>
                  <p>
                    Click <strong>Add</strong>, then sign in through the OAuth
                    flow to connect your account.
                  </p>
                </div>
              </li>
              <li>
                <span className="claude-step-number">6</span>
                <div>
                  <h3>Enable it per chat</h3>
                  <p>
                    In any conversation, toggle the connector on via{` `}
                    <strong>+</strong> &gt; <strong>Connectors</strong>.
                  </p>
                </div>
              </li>
            </ol>
          </div>
        </section>

        <section className="referrals-sec">
          <div className="container">
            <div className="head-top-content">
              <h2>Improve Client Retention & Referrals</h2>
              <p>
                Deliver a smooth project experience that keeps clients coming
                back and recommending your services.
              </p>
            </div>
            <a
              href="#"
              className="get-start-btn"
              onClick={(e) => scrollToId(e, "pricing")}
            >
              Get Started!
            </a>
            <div className="referrals-slider">
              <Slider {...referralSlider}>
                <div className="referrals-box">
                  <h5>It’s just incredible!</h5>
                  <p>
                    It’s been just a month since I started using HappyEnding,
                    and the experience has been amazing! Managing my daily tasks
                    has never been easier, and I feel more in control of my
                    time.{" "}
                  </p>
                  <div className="bdr">&nbsp;</div>
                  <div className="referrals-user">
                    <img
                      src={referralsUser1}
                      alt="referralsUser1"
                      className="referralsUser"
                    />
                    <div className="referrals-user-name">
                      <label>Jimmy Bartney</label>
                      <p>Product Manager at Picko Lab</p>
                    </div>
                  </div>
                </div>

                <div className="referrals-box">
                  <h5>Satisfied User Here!</h5>
                  <p>
                    Never thought managing my personal and professional life
                    could be this easy! HappyEnding has been a game-changer.
                    I’ve been using it for three months now, and I can’t imagine
                    my routine without it!{" "}
                  </p>
                  <div className="bdr">&nbsp;</div>
                  <div className="referrals-user">
                    <img
                      src={referralsUser2}
                      alt="referralsUser1"
                      className="referralsUser"
                    />
                    <div className="referrals-user-name">
                      <label>Natasha Romanoff</label>
                      <p>Black Widow</p>
                    </div>
                  </div>
                </div>
                <div className="referrals-box">
                  <h5>No Doubt, HappyEnding is the Best!</h5>
                  <p>
                    “The best” – that’s what I’d say about HappyEnding! I never
                    knew such a platform existed to simplify my life so much.
                    Highly recommended for anyone looking to enhance their
                    productivity and happiness!{" "}
                  </p>
                  <div className="bdr">&nbsp;</div>
                  <div className="referrals-user">
                    <img
                      src={referralsUser3}
                      alt="referralsUser1"
                      className="referralsUser"
                    />
                    <div className="referrals-user-name">
                      <label>Moritika Kazuki</label>
                      <p>Finance Manager at Mangan</p>
                    </div>
                  </div>
                </div>
              </Slider>
            </div>
          </div>
        </section>

        <section className="plan-sec" id="pricing">
          <div className="container">
            <div className="head-top-content">
              <h2>Simple, Transparent, No Surprises</h2>
              <p>Choose a plan that suits your business needs</p>
            </div>
            {/* <div className="Choose-plan-head">
              <div className="payment-switch">
                <p>Monthly </p>
                <div className="payment-switch-form">
                  <input type="checkbox" hidden="hidden" id="plan-type" />
                  <label className="switch" for="plan-type"></label>
                </div>
                <p>Yearly</p>
              </div>
              <button className="save-btn">Save 65%</button>
            </div> */}
            <div className="pricing-details row justify-content-center">
              {isLoading ? (
                <div className="pt-5">{selectLoader(50)}</div>
              ) : (
                plans.map((plan) => {
                  const priceObj = plan.prices?.[0]; // assume one price per plan
                  const monthlyPrice = (priceObj?.price || 0) / 100; // cents to dollars

                  return (
                    <div
                      className="col-lg-4 col-md-12 col-sm-12 annually"
                      key={plan.id}
                    >
                      <div className="pricing-detailsCard">
                        <h6>
                          <img src={lovely} alt="plan-icon" />{" "}
                          {plan.externalName}
                        </h6>
                        <span>
                          ${monthlyPrice.toFixed(2)}{" "}
                          <sup>
                            /{" "}
                            {priceObj?.period_unit === "month"
                              ? "Month"
                              : priceObj?.period_unit}
                          </sup>
                        </span>
                        {/* Safely inject features list from description */}
                        <div
                          dangerouslySetInnerHTML={{
                            __html: plan.description
                              .replace(
                                /<li>/g,
                                `<li class="active"><img src="${tickCircleWhite}" alt="tick" /><p>`,
                              )
                              .replace(/<\/li>/g, "</p></li>"),
                          }}
                        />

                        <button
                          className="enroll-btn"
                          onClick={() => activateSubscription(priceObj?.id)}
                          disabled={isActivating}
                        >
                          {isActivating ? selectLoader(20) : "Get Started"}
                        </button>
                      </div>
                    </div>
                  );
                })
              )}
              {/* <div className="col-lg-4 col-md-12 col-sm-12 monthly">
                <div className="pricing-detailsCard">
                  <div className="crownPro-cover">
                    <h6>
                      {" "}
                      <img src={crownPro} alt="crownPro" /> Pro
                    </h6>
                    <button className="popular-btn">Popular</button>
                  </div>
                  <p>Perfect plan for professionals!</p>
                  <span>
                    $12 <sup>/ Month</sup>
                  </span>
                  <h5>Ideal for professionals managing multiple milestones.</h5>
                  <ul>
                    <li className="active">
                      <img src={tickCircleWhite} alt="tickCircleWhite" />
                      <p>Everything in Starter Plan</p>
                    </li>
                    <li className="active">
                      <img src={tickCircleWhite} alt="tickCircleWhite" />
                      <p>Change Order Management</p>
                    </li>
                    <li className="active">
                      <img src={tickCircleWhite} alt="tickCircleWhite" />
                      <p>Milestone tracking</p>
                    </li>
                    <li className="active">
                      <img src={tickCircleWhite} alt="tickCircleWhite" />
                      <p>AI-driven recommendations</p>
                    </li>
                    <li>
                      <img src={closeCircle} alt="closeCircle" />
                      <p>Full-suite automation</p>
                    </li>
                  </ul>
                  <a href="#" className="enroll-btn">
                    Get Started
                  </a>
                </div>
              </div>
              <div className="col-lg-4 col-md-12 col-sm-12 annually ">
                <div className="pricing-detailsCard ">
                  <h6>
                    <img src={share} alt="crownPro" /> Enterprise
                  </h6>
                  <p>Best suits for great company!</p>
                  <span>
                    $33 <sup>/ Month</sup>
                  </span>
                  <h5>Best for large teams needing full automation.</h5>
                  <ul>
                    <li className="active">
                      <img src={tickCircleWhite} alt="tickCircleWhite" />
                      <p>Everything in Pro Plan</p>
                    </li>
                    <li className="active">
                      <img src={tickCircleWhite} alt="tickCircleWhite" />
                      <p>Full-suite automation</p>
                    </li>
                    <li className="active">
                      <img src={tickCircleWhite} alt="tickCircleWhite" />
                      <p>Advanced integrations</p>
                    </li>
                    <li className="active">
                      <img src={tickCircleWhite} alt="tickCircleWhite" />
                      <p>Priority support</p>
                    </li>
                    <li className="active">
                      <img src={closeCircle} alt="closeCircle" />
                      <p>Custom workflow automations</p>
                    </li>
                  </ul>
                  <a href="#" className="enroll-btn">
                    Get Started
                  </a>
                </div>
              </div> */}
            </div>
          </div>
        </section>

        <section className="faq-sec" id="faqs">
          <div className="container">
            <div className="head-top-content">
              <h2>
                You Asked, We Answered – FAQs <span>❓</span>
              </h2>
              <p>
                We know you have questions, and we’re here with the answers!
                Below are some of the most frequently asked questions to help
                you get the most out of our platform.
              </p>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <Accordion defaultActiveKey="0">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                      How is this different from project management tools?
                    </Accordion.Header>
                    <Accordion.Body>
                      <p>
                        We work alongside PM tools, focusing on client
                        communication, approvals, and expectation management.
                      </p>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="1">
                    <Accordion.Header>
                      What if my clients don’t use the platform?
                    </Accordion.Header>
                    <Accordion.Body>
                      <p>
                        They don’t need to! They’ll get updates via email, SMS,
                        or app—whatever they prefer.
                      </p>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="2">
                    <Accordion.Header>
                      How will this make my projects more profitable?
                    </Accordion.Header>
                    <Accordion.Body>
                      <p>
                        By ensuring you never work for free—every request gets
                        approved and billed before you do the work.
                      </p>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="3">
                    <Accordion.Header>
                      What if my projects involve frequent changes or evolving
                      scopes?
                    </Accordion.Header>
                    <Accordion.Body>
                      <p>
                        Happy Ending is built for dynamic projects. Change
                        requests are easily converted into structured change
                        orders with optional quotes, so you’re always in control
                        of timeline and budget impacts.
                      </p>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </div>
            </div>
          </div>
        </section>

        <section className="business-sec">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 col-md-6">
                <div className="business-content">
                  <h3>Your Business, Your Rules – Access It Anywhere</h3>
                  <p>
                    Take control of your projects with our powerful mobile and
                    web applications. Whether you’re in the office or on the
                    move, stay connected with your clients, streamline
                    workflows, and maximize profits—all from one intuitive
                    platform.
                  </p>
                  <div className="play-btn-group">
                    <a href="#">
                      {" "}
                      <img src={appPlay} alt="appPlay" />
                    </a>
                    <a href="#">
                      {" "}
                      <img src={googlePlay} alt="googlePlay" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-6">
                <img src={mobilApp} alt="mobilApp" className="mobilApp" />
              </div>
            </div>
          </div>
        </section>

        <section className="innovate-sec">
          <div className="container">
            <div className="head-top-content">
              <h2>Innovate & Inspire: Your Daily Dose of Ideas</h2>
              <p>
                Bringing thoughts to reality through engaging stories and
                insightful discussions.
              </p>
            </div>
            <div className="row">
              {blogsList?.map((post) => (
                <div
                  key={post._id}
                  className="col-lg-4 col-md-6 col-sm-6 col-xs-12"
                >
                  <div className="innovate-box">
                    <img
                      src={post.image}
                      alt={post.title}
                      className="innovatImg"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        viewBlogPost(post.slug);
                      }}
                    />
                    <div className="innovate-content">
                      <a href="">{post.categoryId?.name}</a>
                      <p
                        className="card-title"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          viewBlogPost(post.slug);
                        }}
                      >
                        {post.title}
                      </p>
                      <div className="user-content">
                        <div className="userName">
                          <img
                            src={post.authorImage || avatarImage} // Fallback image if not available
                            alt={post.authorName}
                            className="popularPost"
                          />
                          <p>{post.authorName}</p>
                        </div>
                        <p>{formatDate(post.createdDate)}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <Link className="view-all-btn" to={"bloglist"}>
              View All
            </Link>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Home;
